import {EnvironmentProviders, makeEnvironmentProviders, Provider} from '@angular/core';
import {TOAST_CONFIG} from './entities/base';
import {DefaultNoComponentGlobalConfig, IConfigGlobal} from './entities/config.global';
import {ToastComponent} from './toast.component';

export const DefaultGlobalConfig: IConfigGlobal = {
  ...DefaultNoComponentGlobalConfig,
  toastComponent: ToastComponent,
};

/**
 * @description
 * Provides the `TOAST_CONFIG` token with the given config.
 *
 * @param config The config to configure toastr.
 * @returns The environment providers.
 *
 * @example
 * ```ts
 * import { provideToastr } from 'ngx-toastr';
 *
 * bootstrap(AppComponent, {
 *   providers: [
 *     provideToast({
 *       timeOut: 2000,
 *       positionClass: 'toast-top-right',
 *     }),
 *   ],
 * })
 */
export const provideToast = (config: Partial<IConfigGlobal> = {}): EnvironmentProviders => {
  const providers: Provider[] = [
    {
      provide: TOAST_CONFIG,
      useValue: {
        default: DefaultGlobalConfig,
        config,
      },
    },
  ];

  return makeEnvironmentProviders(providers);
};
